import { isValidPhoneNumber } from 'react-phone-number-input'


export const yupPhoneTestOptions = {
  message: `Please enter a valid phone number`,
  test: (phone?: string) => {
    if (!phone)
      return true;
    return isValidPhoneNumber(phone);
  }
}
